import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Contractdate } from './contractdate.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class ContractdateService {

    private resourceUrl = 'api/contractdates';
    private resourceSearchUrl = 'api/_search/contractdates';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(contractdate: Contractdate): Observable<Contractdate> {
        const copy: Contractdate = Object.assign({}, contractdate);
        copy.realDate = this.dateUtils.toDate(contractdate.realDate);
        copy.originalDate = this.dateUtils.toDate(contractdate.originalDate);
        copy.evasiveDate = this.dateUtils.toDate(contractdate.evasiveDate);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(contractdate: Contractdate): Observable<Contractdate> {
        const copy: Contractdate = Object.assign({}, contractdate);

        copy.realDate = this.dateUtils.toDate(contractdate.realDate);

        copy.originalDate = this.dateUtils.toDate(contractdate.originalDate);

        copy.evasiveDate = this.dateUtils.toDate(contractdate.evasiveDate);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Contractdate> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            const jsonResponse = res.json();
            jsonResponse.realDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.realDate);
            jsonResponse.originalDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.originalDate);
            jsonResponse.evasiveDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.evasiveDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    private convertResponse(res: any): any {
        const jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].realDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].realDate);
            jsonResponse[i].originalDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].originalDate);
            jsonResponse[i].evasiveDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].evasiveDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        const options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            const params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate.service.ts